var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orb"},[_c('canvas',{staticClass:"orb__canvas no-swipe-nav"}),_vm._v(" "),_c('div',{staticClass:"orb__pano no-swipe-nav"}),_vm._v(" "),_c('div',{staticClass:"orb__preloader no-swipe-nav",style:({width: _vm.loadedPercent, opacity: !_vm.loaded ? 1 : 0})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0492df92","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/Orb.vue
// module id = null
// module chunks = 